import React from 'react';
import { motion } from 'framer-motion';
export function LifeBack() {
  return <section className="py-24 bg-white border-y border-gray-200" data-id="element-323">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-324">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-325">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-8" data-id="element-326">
            THE LIFE YOU GET BACK{' '}
            <span className="text-[#C8102E]" data-id="element-327">WHEN IT'S GONE</span>
          </h2>

          <p className="text-2xl text-gray-600 mb-10 font-medium" data-id="element-328">
            Think about what happens AFTER the job is done.
          </p>

          <div className="text-left max-w-2xl mx-auto space-y-4 text-lg text-gray-700 bg-[#F9F9F9] p-8 rounded-lg border border-gray-100 shadow-sm mb-10" data-id="element-329">
            <p data-id="element-330">
              ✓ You walk into the garage and for the first time in years —
              there's space. Real, usable space.
            </p>
            <p data-id="element-331">✓ The backyard looks like a backyard again.</p>
            <p data-id="element-332">✓ The property is ready to list.</p>
            <p data-id="element-333">✓ The contractor can finally start.</p>
            <p data-id="element-334">✓ The tenant space is clean and rentable.</p>
            <p data-id="element-335">✓ The estate is cleared and the family can move forward.</p>
          </div>

          <p className="text-3xl font-bold text-[#1A1A1A] uppercase tracking-wide" data-id="element-336">
            That's what we're really selling you. <br data-id="element-337" />
            Not junk removal. <br data-id="element-338" />
            <span className="text-[#C8102E]" data-id="element-339">
              Space. Peace of mind. A fresh start.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}